import React from 'react';
import '../blogs.module.css'
import { Mutation } from 'react-apollo';
import { BLOCK_USER, DELETE_BLOG_COMMENT } from '../queries';

const CommentOverflow = ({comment,refetch}) => {
    return (
        <div className='commentOverflow'>
            <Mutation mutation={DELETE_BLOG_COMMENT} variables={{commentId:comment.id}}>
            {(deleteComment, { loading, error }) => (
                <div className='overflowOption' onClick={() => {
                    deleteComment();
                    refetch();
                    }}>
                    Delete comment
                </div>
            )}
            </Mutation>
            <Mutation mutation={BLOCK_USER} variables={{userId:comment.commentedBy}}>
            {(blockUser, { loading, error }) =>  (
                <div className='overflowOption' onClick={() => {
                    blockUser();
                    refetch();
                    }}>
                    Block user
                </div>
            )}
            </Mutation>
        </div>
    )
}

export default CommentOverflow;


// WEBPACK FOOTER //
// ./src/components/Blogs/Comments/CommentOverflow.js